/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LolaProxyService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Acces direct a Lola
     * Transmet l'appel a Lola (`/lola/<endpoint>`) avec les parametres recus et renvoie sa reponse sans transformation. Reserve aux besoins qui n'ont pas encore d'endpoint dedie.
     * @param any
     * @returns string
     * @throws ApiError
     */
    public lolaProxyLolaProxy(
        any: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/lola/{any}',
            path: {
                'any': any,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
